module.exports = __webpack_public_path__ + "static/desktop/img/case8.c5259e80.jpg";